/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_A7Inputs */

const en_viewer_faq_a7 = /** @type {(inputs: Viewer_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each node carries a path written the way you would write it in code, with dots for object keys and bracketed indices for array elements, rooted at root. Drop the leading root and you have an accessor you can paste into your own code.`)
};

const ko_viewer_faq_a7 = /** @type {(inputs: Viewer_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 노드는 코드에 쓰는 방식대로 된 경로를 지닙니다. 객체 키에는 점, 배열 요소에는 대괄호 인덱스를 쓰며 root에서 시작합니다. 앞의 root를 떼면 자기 코드에 붙여넣을 수 있는 접근자가 됩니다.`)
};

const ja_viewer_faq_a7 = /** @type {(inputs: Viewer_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各ノードはコードに書くとおりの形のパスを持ちます。オブジェクトキーにはドット、配列要素には角かっこの添字を使い、root から始まります。先頭の root を落とせば、自分のコードに貼れるアクセサになります。`)
};

/**
* | output |
* | --- |
* | "Each node carries a path written the way you would write it in code, with dots for object keys and bracketed indices for array elements, rooted at root. Drop..." |
*
* @param {Viewer_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_a7 = /** @type {((inputs?: Viewer_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_a7(inputs)
	if (locale === "ko") return ko_viewer_faq_a7(inputs)
	return ja_viewer_faq_a7(inputs)
});